import styled from "styled-components";
import { useMyContext } from "@/app/utils/MyContext";
import MenuTab from "../components/MenuTab";
import { MenuTab as MenuTabClass, RaceNo } from "@/app/utils/class/common/base";
import { setRacesDetailLoading, setRouting } from "@/app/utils/Common";
import { text_size } from "@/app/utils/MixinSize";
import { useLanguage } from "@/app/utils/LanguageContext";
import { useEffect, useState, useRef } from "react";
import RenderTabPanel from "../components";
import { menuTabSet } from "@/app/utils/constant/menuTabSet";
import RacingInfo from "@/app/ui/RaceDetail/components/RacingInfo";

import "@/app/style/comm.scss";
import Box from "@mui/material/Box";

const Container = styled.div`
  width: 100%;
  padding: 5px 8px 0 8px;
`;
const Content = styled.div`
  border-radius: 1.06vw 1.06vw 0 0;
`;
const Title = styled.p`
  padding: 11.8px 12px;
  border-radius: 1.06vw 1.06vw 0 0;
  background: rgba(19, 43, 104, 1);
  color: white;
  ${text_size(15)}
  font-weight: 500;
  line-height: 18px;
  text-align: left;
`;

type propType = {
  menuData: any;
  meetings: IMeeting[];
  onTips2Dismiss?: () => void;
  clickTipOnly?: boolean;
  showTips2?: any;
  showTips1?: any;
  onTips1Dismiss?: () => void;
  setRacesDetailLoading: (loading: boolean) => void;
  isLoadingRacesDetail: boolean;
};
const RaceDetail: React.FC<propType> = (props) => {
  const { state: lang } = useLanguage();
  const { state: myContextState, dispatch: myContextDispatch } = useMyContext();
  const anchor = useRef<HTMLDivElement | null>(null);

  // const [clickTipOnly, setClickTipOnly] = useState(true);
  // const [showTips1,setShowTips1] = useState(true)
  // const [showTips2, setShowTips2] = useState(false)

  const handleTabChange = (tab: string) => {
    const newTab = new MenuTabClass(tab)
    if (newTab.isValid()) {
      const lastSegment = window.location.pathname.split('/').pop();
      if (encodeURIComponent(newTab.valueOf()) !== lastSegment) {
        setRacesDetailLoading(props.setRacesDetailLoading, newTab.toString(), true);
      }
      console.log('route 6')
      //results page, click all button(raceNo=all), and click other tab page, set raceNo=defaultRaceNo
      if (!myContextState.selectedRaceNo.isValid(newTab)) {
        setRouting(`/${encodeURIComponent(newTab.valueOf())}`, { 'RaceNo': myContextState.defaultRaceNo?.toParams(), 'b_cid': '' }, myContextState);
        myContextDispatch({ type: "update", value: { menuTab: newTab, selectedRaceNo: myContextState.defaultRaceNo } });
      } else {
        setRouting(`/${encodeURIComponent(newTab.valueOf())}`, { 'b_cid': '' }, myContextState);
        myContextDispatch({ type: "update", value: { menuTab: newTab } });
      }
    }
  };

  // useEffect(()=>{
  //   const tipDismissed = JSON.parse(localStorage.getItem('tipDismissed') || '{}');
  //   const isTip1Dismissed = tipDismissed.tip1;
  //   const isTip2Dismissed = tipDismissed.tip2;

  //   if(isTip1Dismissed){
  //     setShowTips1(false);
  //     if(!isTip2Dismissed){
  //       setShowTips2(true);
  //     }else{
  //       setClickTipOnly(false);
  //     }
  //   }
  // },[]);

  // const handleTip1Dismiss = ()=>{
  //   setShowTips1(false)
  //   setShowTips2(true)
  // }

  // useEffect(()=>{
  //   if (!showTips2 || myContextState.isLoadingRaces) return;
  //   if (myContextState.selectedMeeting?.isPresite()){
  //     if (clickTipOnly) {
  //       handleTip2Dismiss();
  //     }
  //   } else {
  //     setClickTipOnly(true);
  //   }
  // }, [showTips2, myContextState.isLoadingRaces, myContextState.selectedMeeting])

  // const handleTip2Dismiss = ()=>{
  //   setClickTipOnly(false);
  //   document.querySelector('div:first-child')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  // }

  const handleSelectRace = (raceNo: number) => {
    if (raceNo != -1 && raceNo !== myContextState.selectedRaceNo.valueOf()) {
      setRacesDetailLoading(props.setRacesDetailLoading, myContextState.menuTab.toString(), true, true);
      //setSelectedRaceNo(raceNo);
      myContextDispatch({
        type: "update",
        value: { selectedRaceNo: new RaceNo(raceNo) },
      });
    }
  };

  const raceSelectorData =
  {
    [myContextState?.selectedMeetingVenueCode]: { races: [1, 2, 3, 4, 5, 6, 7] },
    ["S2"]: { races: [1, 2, 3, 4, 5] },
    ["S3"]: { races: [1, 2, 3, 4, 5] }
  }


  return (
    <>
      <Container className={myContextState.isLoadingRaces ? 'loading' : ''} style={{ padding: "0" }} ref={anchor}>
        <Content>
          <div id='race_detail_wrapper'>
            {/* <Title id="race_detail_name">{myContextState.selectedMeeting?.getTitle(myContextState.selectedRace)}</Title> */}

            <MenuTab
              onChange={handleTabChange}
              type="mobile"
              onTips2Display={() => anchor?.current?.scrollIntoView({ behavior: 'smooth', block: 'start' })}
              onTips2Dismiss={props?.onTips2Dismiss}
              clickTipOnly={props?.clickTipOnly}
              showTips2={props?.showTips2}
              menuData={props?.menuData}
              setRacesDetailLoading={props.setRacesDetailLoading}
            // {...props}
            />

          </div>

          <RacingInfo
            type="mobile"
            meetings={props.meetings}
            setRacesDetailLoading={props.setRacesDetailLoading}
            handleSelectRace={handleSelectRace}
            showTips1={props?.showTips1}
            onTips1Dismiss={props?.onTips1Dismiss}
          //raceSelectorData={raceSelectorData}
          />
          <RenderTabPanel
            type="mobile"
            setRacesDetailLoading={props.setRacesDetailLoading}
            isLoadingRacesDetail={props.isLoadingRacesDetail}
            meetings={props.meetings}
          />
        </Content>
      </Container>
    </>
  );
};
export default RaceDetail;
